type Feature = {
	name: string
	description: string
	icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
}

type FeatureProps = {
	header: string
	features: Feature[]
	image: string
	description?: string
	align?: 'left' | 'right'
}

const Features = ({
	features,
	header,
	description = '',
}: {
	features: Feature[]
	header: string
	description: string
}) => (
	<div className='px-6 lg:px-0 lg:pr-4 lg:pt-4'>
		<div className='mx-auto max-w-2xl lg:mx-0 lg:max-w-lg'>
			{/* <h2 className="text-xl font-semibold leading-7 text-binz-red">{header}</h2> */}
			<p className='mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'>
				{description}
			</p>
			<dl className='mt-10 max-w-xl space-y-8 text-2xl leading-7 text-gray-600 lg:max-w-none'>
				{features.map((feature) => (
					<div
						key={feature.name}
						className='relative pl-12'
					>
						<dt className='inline font-semibold text-gray-900'>
							<feature.icon
								aria-hidden='true'
								className='absolute left-1 top-0 h-8 w-8 text-binz-red'
							/>
						</dt>{' '}
						<dd
							className='inline text-gray-800'
							dangerouslySetInnerHTML={{ __html: feature.description }}
						/>
					</div>
				))}
			</dl>
		</div>
	</div>
)

const FeatureImage = ({ image }: { image: string }) => (
	<div className='sm:px-6 lg:px-0'>
		<div className='w-2xl relative isolate overflow-hidden bg-binz-blue px-6 pt-8 sm:mx-auto sm:rounded-3xl sm:pl-16 sm:pr-0 sm:pt-16 lg:mx-0 lg:max-w-none'>
			<div
				aria-hidden='true'
				className='absolute -inset-y-px -left-3 -z-10 w-full origin-bottom-left skew-x-[-30deg] bg-binz-blue opacity-20 ring-1 ring-inset ring-white'
			/>
			<div className='mx-auto max-w-2xl sm:mx-0 sm:max-w-none'>
				<img
					alt='Product screenshot'
					src={image}
					className=''
				/>
			</div>
			<div
				aria-hidden='true'
				className='pointer-events-none absolute inset-0 ring-1 ring-inset ring-black/10 sm:rounded-3xl'
			/>
		</div>
	</div>
)

export default function FeaturesBlock({
	header,
	features,
	image,
	description = '',
	align = 'right',
}: FeatureProps) {
	return (
		<div className='overflow-hidden bg-white py-8 sm:py-16'>
			<div className='mx-auto max-w-7xl md:px-6 lg:px-8'>
				<div className='grid grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:grid-cols-2'>
					{align === 'right' ? (
						<>
							<Features
								header={header}
								features={features}
								description={description}
							/>
							<FeatureImage image={image} />
						</>
					) : (
						<>
							{' '}
							<FeatureImage image={image} />
							<Features
								header={header}
								features={features}
								description={description}
							/>
						</>
					)}
				</div>
			</div>
		</div>
	)
}
